import { useIonToast } from '@ionic/react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { InAppNotificationPresenter } from './InAppNotificationPresenter';

export const InAppNotificationBinder = () => {
    const presenter = useInstance(InAppNotificationPresenter);
    const [showToast] = useIonToast();
    presenter._setToastMethods({ showToast });
    return null;
};
